import axios from 'axios';

import { ModelProps } from '../types/model';
import { getBaseUrl } from './getBaseUrl';

// ### Function calls report API with current policy model, receives pdf and triggers browser download

export const downloadCoverageDecreasingProgression = async (model: ModelProps) => {
    // ### Endpoint must accept POST — browsers cannot send a GET request with a json body
    const response = await axios.post(
        `${getBaseUrl()}api/online/misc/get-coverage-decreasing-progression-document`,
        model,
        { responseType: 'blob' }
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'prehled-vyvoje-pojistne-castky.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
